import { useEffect } from 'react';
import {
  MapContainer,
  Marker,
  TileLayer,
  useMap,
  useMapEvents,
} from 'react-leaflet';
import type { Point } from '@/lib/api.types';
import { ienoneMarkerActiveIcon } from '@/lib/leaflet-setup';
import { GSI_ATTRIBUTION_HTML, TILES } from '@/lib/tiles';
import styles from './SiteMap.module.css';

type Props = {
  point?: Point | null;
  onClick: (point: Point) => void;
};

function MapClickHandler({ onClick }: { onClick: (p: Point) => void }) {
  useMapEvents({
    click(e) {
      onClick({ lon: e.latlng.lng, lat: e.latlng.lat });
    },
  });
  return null;
}

function MapCenterUpdater({ point }: { point?: Point | null }) {
  const map = useMap();
  useEffect(() => {
    if (!point) return;
    map.setView([point.lat, point.lon], Math.max(map.getZoom(), 15), {
      animate: true,
    });
  }, [point, map]);
  return null;
}

export default function SiteMap({ point, onClick }: Props) {
  const center: [number, number] = point
    ? [point.lat, point.lon]
    : [35.681236, 139.767125];

  return (
    <div className={styles.wrap}>
      <MapContainer
        center={center}
        zoom={13}
        scrollWheelZoom={false}
        className={styles.map}
      >
        {/* crossOrigin は章マップ (OverviewMiniMap) と同じ理由 (PDF 用 canvas 描画のキャッシュ整合)。 */}
        <TileLayer
          url={TILES.std}
          attribution={GSI_ATTRIBUTION_HTML}
          maxZoom={18}
          crossOrigin="anonymous"
        />
        <MapClickHandler onClick={onClick} />
        <MapCenterUpdater point={point} />
        {point && (
          <Marker position={[point.lat, point.lon]} icon={ienoneMarkerActiveIcon} />
        )}
      </MapContainer>
    </div>
  );
}
